import './Breadcrumbs.scss'

import React from 'react'

import { translated } from '../_translation'

/**
 * @typedef {Object} BreadcrumbItem
 * @property {string} label
 * @property {string} [url]
 */

/**
 * @param {Object} props
 * @param {BreadcrumbItem[]} [props.items]
 * @param {string} props.currentLabel
 * @param {string} props.rootUrl
 */
const Breadcrumbs = ({ gettext, items, currentLabel, rootUrl }) => {
    const home = gettext('Home')

    return (
        <ul className="breadcrumbs">
            <li>
                <a href={rootUrl}>
                    <i className="i-home" title={home} />
                </a>
                <i className="i-chevron-right text-secondary" />
            </li>
            {items.map(({ url, label }, i) => (
                <li key={i}>
                    <a href={url}>{label}</a>
                    <i className="i-chevron-right text-secondary" />
                </li>
            ))}
            <li className="active">
                {currentLabel}
            </li>
        </ul>
    )
}

export default translated(Breadcrumbs)
